module.exports = "/shifts/components/unavailabilityHistoryScreen-53a411.html";